import { render, staticRenderFns } from "./email-verify.vue?vue&type=template&id=761756f6&scoped=true"
import script from "./email-verify.vue?vue&type=script&lang=js"
export * from "./email-verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761756f6",
  null
  
)

export default component.exports